import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'ng2-select/ng2-select';

import { Ng2SelectExtComponent } from "./ng2-select-ext.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SelectModule, 
    ],
    declarations: [
        Ng2SelectExtComponent,
    ],
    exports: [
        Ng2SelectExtComponent,
    ]
})
export class Ng2SelectModule { }